import { render, staticRenderFns } from "./GatherPraise.vue?vue&type=template&id=a1cbcc7e&"
import script from "./GatherPraise.vue?vue&type=script&lang=js&"
export * from "./GatherPraise.vue?vue&type=script&lang=js&"
import style0 from "./GatherPraise.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1cbcc7e')) {
      api.createRecord('a1cbcc7e', component.options)
    } else {
      api.reload('a1cbcc7e', component.options)
    }
    module.hot.accept("./GatherPraise.vue?vue&type=template&id=a1cbcc7e&", function () {
      api.rerender('a1cbcc7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/MarketingChildren/GatherPraise.vue"
export default component.exports